import { InjectionToken } from '@angular/core'

export const WINDOW = new InjectionToken<string>('fs.wnd')
export const WINDOW_IS_DEFINED = new InjectionToken<string>('fs.wnd-def')
